const ACCEPTED_KEY = 'catalogofworks-cookie-consent';
const COOKIE_NAME = 'catalogofworks_cookie_consent';
const CONSENT_CHANGED_EVENT = 'catalogofworks-cookie-consent-changed';

const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 365;

function readConsentCookie(): boolean {
  if (typeof document === 'undefined') return false;
  const prefix = `${COOKIE_NAME}=`;
  return document.cookie.split(';').some((part) => part.trim() === `${prefix}accepted`);
}

function writeConsentCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_NAME}=accepted; Max-Age=${COOKIE_MAX_AGE_SEC}; Path=/; SameSite=Lax`;
}

function emitConsentChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
}

export function subscribeCookieConsentChanged(onChange: () => void): () => void {
  window.addEventListener(CONSENT_CHANGED_EVENT, onChange);
  return () => window.removeEventListener(CONSENT_CHANGED_EVENT, onChange);
}

export function hasAcceptedCookieNotice(): boolean {
  try {
    if (localStorage.getItem(ACCEPTED_KEY) === 'accepted') return true;
  } catch {
    /* ignore */
  }
  return readConsentCookie();
}

export function acceptCookieNotice(): void {
  try {
    localStorage.setItem(ACCEPTED_KEY, 'accepted');
  } catch {
    /* ignore quota / private mode */
  }
  writeConsentCookie();
  emitConsentChanged();
}
